var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg034Pull = function Svg034Pull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M211 421h90v-90h60v-60H151v60h60zm30-90h30v60h-30z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61 512h390V0H61zm150-391V61h90v60h51.211L256 217.211 159.789 121zm-90 120h270v120h-60v90H181v-90h-60z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M279.789 151H271V91h-30v60h-8.789L256 174.789z"
  })));
};
export default Svg034Pull;